
//=require ../vendor/imarcom/open-modal/locales/fr.js

var locale = {
    "language" : "fr",
    "caps_lock_on" : "La touche Verr. Majuscule est active.",
    "download" : "Télécharger",
    "browse_and_attach" : "Téléverser et attacher",
    "checkout" : "Commande en ligne",
    "clean_base_site_url" : "/",
    "file_upload_max_qty_exceed" : "La limite de fichiers téléchargeables simultanément est de <strong>%s</strong>.",
    "public_max_file_upload_size" : "50000000",
    "file_upload_type_invalid" : "Seulement les fichiers de type '<strong>%s</strong>' sont acceptés.",
    "public_file_upload_progress" : "Téléversement en cours...",
    "file_upload_max_size_exceed" : "La taille du fichier '%s' dépasse la limite permise de %sMo",
    "upload_file_error_uploading" : "Une erreur est survenue durant le téléversement du/des fichiers :",
    "remaining_characters" : "%s caractère(s) restant(s)",
    "auto_ajax_url" : "/ajax.do",
    "public_form_ajax_url" : "/public_form",
    "language" : "fr",
    "phone" : "Téléphone",
    "email" : "Courriel",
    "password_meter" : "Qualité du mot de passe",
    "password_level_0" : "Votre mot de passe est faible",
    "password_level_1" : "Vous pouvez faire mieux que ça...",
    "password_level_2" : "Votre mot de passe est un peu faible",
    "password_level_3" : "Bon mot de passe, pourraient être mieux encore",
    "password_level_4" : "Bon mot de passe !",
    "password_level_5" : "Super mot de passe !",
    "error_unknown_append" : "Une erreur inconnue s'est produite.",
    "error_try_again_later" : "Veuillez réessayer plus tard.",
    "session_expired_title" : "Votre session client a expiré.",
    "session_expired_text" : "<p>Votre délai de connexion dans notre espace sécurisé est expiré. Votre session est donc terminée pour des raisons de sécurité et de protections de vos données personnelles. Pour continuer, il vous suffit de vous identifier de nouveau à notre site.</p><p>Merci de votre compréhension.</p>",
    "error_append" : "Une erreur s'est produite.",
    "close" : "Fermer",
    "select_country" : "Sélectionnez votre Pays",
    "select_state" : "Sélectionnez votre État",
    "select_province" : "Sélectionnez votre Province",
    "select_region" : "Sélectionnez votre Région",
    "select_county" : "Sélectionnez votre Municipalité",
    "newsletter.subscription" : "Abonnement infolettre",
    "newsletter.invalid_email" : "Oups! L'adresse courriel est invalide. S'il vous plaît utilisez une adresse courriel valide.",
    "newsletter.invalid_domain" : "Oups! Le nom de domaine utilisé est invalide. S'il vous plaît vérifiez un domaine valide.",
    "newsletter.please_confirm" : "<p class=\"page_title\">S'il vous plaît confirmez!</p><hr><div class=\"content\"><p>Vérifiez votre boîte de réception un courriel de confirmation va vous être envoyé sous peu.</p><p>Pour compléter le processus d'abonnement, vous devez confirmer votre adresse courriel.</p></div>",
    "newsletter.subscribed" : "<p class=\"page_title\">Inscription confirmée!</p><hr><p class=\"content\">Vous recevrez très bientôt votre première infolettre.</p>",
    "newsletter.unknown_error" : "Oups! Une erreur est survenue. Veuillez essayer à nouveau.",
    "confirmation" : "Confirmation",
    "yes" : "Oui",
    "no" : "Non",
    "recaptcha" : "Vous devez confirmer le reCAPTCHA"

    /**
     * Locale pour site actuel ICI
     */
};

